import { useLocation } from 'js/lib/useRouter';

import {
  DEFAULT_SEARCH_FILTERS,
  extendDefaultFilterList,
} from 'bundles/search-common/components/filters/getFiltersList';
import { useShowCourseraTier } from 'bundles/search-common/providers/LearnerProvider';
import { shouldShowFreeQueryPageConfigPreview } from 'bundles/search-common/utils/pageConfigUtils';

const useFilterListOrder = (customDefaults?: string[]) => {
  const shouldShowCourseraPlusFilter = useShowCourseraTier();
  const query = useLocation().query.query;
  const shouldShowCostFilter = shouldShowFreeQueryPageConfigPreview(query);
  const defaultList = customDefaults || DEFAULT_SEARCH_FILTERS;
  return extendDefaultFilterList(defaultList, shouldShowCourseraPlusFilter, shouldShowCostFilter);
};

export default useFilterListOrder;
